import { merge, toLower } from 'lodash';
import { IRowNode } from 'ag-grid-community';

export const GROUP_STARTING_COMPARE_LEVEL = 2;

const stringCaseInsensitiveComparator = (valueA, valueB): any => {
  const valueAStr = toLower(valueA);
  const valueBStr = toLower(valueB);

  if (valueAStr === valueBStr) {
    return 0;
  }

  return valueAStr > valueBStr ? 1 : -1;
};

/**
 * get string case insensitive comparator
 *
 * @param options comparator options
 */
const getStrCaseInsensitiveComparator =
  (options: { startingCompareLevel?: number }) =>
  (valueA, valueB, nodeA: IRowNode, nodeB: IRowNode) => {
    const { startingCompareLevel = 0 } = options;

    if (
      nodeA.level < startingCompareLevel ||
      nodeB.level < startingCompareLevel
    ) {
      return 0;
    }

    return stringCaseInsensitiveComparator(valueA, valueB);
  };

/**
 * get group string case insensitive comparator
 *
 * @param options @default startingCompareLevel is GROUP_STARTING_COMPARE_LEVEL
 */
const getGroupStrCaseInsensitiveComparator = (options?: {
  startingCompareLevel?: number;
}) =>
  getStrCaseInsensitiveComparator(
    merge({ startingCompareLevel: GROUP_STARTING_COMPARE_LEVEL }, options),
  );

export {
  stringCaseInsensitiveComparator,
  getStrCaseInsensitiveComparator,
  getGroupStrCaseInsensitiveComparator,
};
